module.exports = __webpack_public_path__ + "img/address-info-blue.e6436f05.svg";